import { useCallback, useEffect, useState } from 'react'
import { Button, Modal, Space, TableProps } from 'antd'
import { SafetyOutlined } from "@ant-design/icons"
import CustomTable from '../../components/table'
import defaultParams from '../../assets/constants/default_params'
import { apiDeleteUser, apiGetListUsers } from '../../api'
import { useLoading } from '../../context/LoadingContext'
import { Link } from 'react-router-dom'
import { ADMIN, CREATE, UPDATE, USER } from '../../assets/constants/route_path'
import { toastError, toastSuccess } from '../../utils/toast'
import ActionEditDelete from '../../components/dropdown/ActionEditDelete'
import { IUser, IUsers } from '../../models/user.model'
import { useSelector } from 'react-redux'
import { authSelector } from '../../redux/slices/authSlice'
import { ADMIN_USERNAME } from '../../config/constants'
import ModalDetailRole from '../role/ModalDetailRole'
import { IRole } from '../../models/role.model'

export default function User() {
    const [users, setUsers] = useState<IUsers>({})
    const [currentPage, setCurrentPage] = useState<number>(defaultParams.PAGE)
    const [pageSize, setPageSize] = useState<number>(defaultParams.LIMIT)
    const [modalDelete, setModalDelete] = useState<{ data: IUser | null, isOpen: boolean }>({
        data: null,
        isOpen: false,
    })
    const [modalDetail, setModalDetail] = useState<{ data: IRole | null, isOpen: boolean }>({
        data: null,
        isOpen: false,
    })

    const { setIsLoading } = useLoading()
    const authState = useSelector(authSelector)
    const { account } = authState

    const columns: TableProps<any>['columns'] = [
        {
            key: 'id',
            title: 'ID',
            dataIndex: 'id',
        },
        {
            key: 'username',
            title: 'Tên đăng nhập',
            dataIndex: 'username',
        },
        {
            key: 'full_name',
            title: 'Tên quản trị viên',
            dataIndex: 'full_name',
        },
        {
            key: 'role',
            dataIndex: 'role',
            title: 'Phân quyền',
            render: (role: IRole) => (
                <Button
                    type='link'
                    onClick={() => setModalDetail({ data: role || null, isOpen: true })}
                    style={{
                        padding: '0',
                        height: 'auto',
                        fontSize: '14px',
                        fontWeight: '500',
                        color: '#1890ff'
                    }}
                >
                    <Space>
                        <SafetyOutlined />
                        {role?.name}
                    </Space>
                </Button>
            ),
        },
        {
            key: 'action',
            title: 'Tác vụ',
            dataIndex: 'action',
            align: 'center',
            render: (_, data: IUser) => (
                <ActionEditDelete
                    canUpdate={account.canUpdateUser}
                    dataUpdate={data}
                    linkUpdate={ADMIN + USER + UPDATE}
                    canDelete={account.canDeleteUser}
                    hanldeDelete={() => setModalDelete({ data, isOpen: true })}
                />
            ),
        },
    ]

    const fetchData = useCallback(async () => {
        try {
            setIsLoading(true)
            const resUsers = await apiGetListUsers({
                limit: pageSize,
                offset: pageSize * (currentPage - 1)
            })
            if (resUsers.data != null) {
                const listUsers = resUsers.data.users.filter((item: IUser) => item.username !== ADMIN_USERNAME)
                resUsers.data.users = listUsers
                setUsers(resUsers.data)
            } else {
                setUsers({})
            }
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
            console.log(error)
        }
    }, [setIsLoading, currentPage, pageSize])

    useEffect(() => {
        fetchData()
    }, [fetchData])

    const handleDelete = async () => {
        try {
            setIsLoading(true)
            const resp = await apiDeleteUser(modalDelete.data?.id)
            if (resp.status === 200) {
                setModalDelete({ data: null, isOpen: false })
                toastSuccess('Xoá quản trị viên thành công!')
                fetchData()
            } else {
                toastError('Có lỗi xảy ra!')
            }
            setIsLoading(false)
        } catch (error) {
            console.log(error);
            toastError('Có lỗi xảy ra!')
            setIsLoading(false)
        }
    }

    return (
        <div>
            <div style={{ textAlign: 'end', marginBottom: 20 }}>
                {account.canAddUser && (
                    <Link to={ADMIN + USER + CREATE}>
                        <Button type='primary'>Thêm quản trị viên</Button>
                    </Link>
                )}
            </div>
            <CustomTable
                namePage='quản trị viên'
                columns={columns}
                dataSource={users.users?.sort((a: IUser, b: IUser) => Number(a.id) - Number(b.id))}
                pageSize={pageSize}
                setPageSize={setPageSize}
                total={users.count}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
            />
            <Modal title='Xoá quản trị viên' open={modalDelete.isOpen}
                onCancel={() => setModalDelete({ data: null, isOpen: false })}
                footer={[
                    <Button onClick={handleDelete} type='primary' danger>
                        Xoá
                    </Button>,
                ]}>
                <div>Bạn có chắc muốn xoá quản trị viên <b>{modalDelete.data?.username}</b>?</div>
            </Modal>
            <ModalDetailRole
                detail={modalDetail}
                setDetail={setModalDetail}
            />
        </div>
    )
}
